import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import sales from "../../../Data/sales.json";
import customers from "../../../Data/customers.json";
import toast from "react-hot-toast";
import moment from "moment";
import Loadercomponent from "../../../Componets/Loader";
import { get_all_sales_returns_report_for_net_sales } from "../../../Controllers/Dashboard/Dashboard";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import ScrollWrapper from "../../../Componets/ScrollWrapper";
import formatDateDDMMYYYY from "../../../Main/formatDate";

const SalesReportDashboard = () => {
    let componentRef = useRef();
    let location = useLocation();

    const [loader, setLoader] = useState(false);
    const [body, setBody] = useState();

    const headers = {
        name: "Sales Returns",
        components: [
            {
                type: "search",
                name: "search",
                placeholder: "Search",
                value: "",
            },
            {
                type: "select",
                name: "sort",
                placeholder: "Sort",
                allowClear: true,
                showSearch: false,
                filterOption: true,
                value: null,
                options: [
                    { value: "0", label: "Price (Low-High)" },
                    { value: "1", label: "Price (High-Low)" },
                ],
            },
            {
                type: "filter",
                name: "customer",
                allowClear: true,
                showSearch: true,
                filterOption: false,
                placeholder: "Customer",
                api: "get-all-customers",
                value: null,
                options: null,
            },
            // {
            //   type: "filter",
            //   name: "branch",
            //   allowClear: true,
            //   showSearch: true,
            //   filterOption: false,
            //   placeholder: "Branch",
            //   api: "get-all-branches",
            //   value: null,
            //   options: null,
            // },
           /*  {
                type: "filter",
                name: "status",
                placeholder: "Status",
                value: null,
                allowClear: true,
                showSearch: false,
                filterOption: true,
                options: [
                    { value: "0", label: "Inactive" },
                    { value: "1", label: "Active" },
                ],
            }, */
            {
                type: "range",
                name: "date",
                value: {
                    start: null,
                    end: null,
                },
            },
          /*   {
                type: "range",
                name: "due_date",
                value: {
                    start: "",
                    end: "",
                },
            }, */
        ],
    };

    const [header, setHeader] = useState(headers);

    const formdata = (data) => {
        fetchData(data);
    };

    const fetchData = async (tabledata) => {
        try {
            setLoader(true);

            const data = {
                search: tabledata?.search,
                sort: tabledata?.sort,
                customer: tabledata?.customer,
                branch: tabledata?.branch,
                status: tabledata?.status,
                date: tabledata?.date,
                due_date: tabledata?.due_date,
            };

            const products = await get_all_sales_returns_report_for_net_sales(data);
            if (products?.status) {
                setBody(products?.data?.data);
                setLoader(false);
            } else {
                toast?.error(products?.message);
                setLoader(false);
            }
        } catch (errors) {
            toast?.error(errors?.message);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const pageStyle = `
  @page {
    size: A4 landscape;
    margin: 10mm;
  }

  @media print {
    body {
      -webkit-print-color-adjust: exact;
    }

    table {
      width: 100%;
      border-collapse: collapse;
    }
  }
`;

    const getPaymentAmount = (payments = [], type) => {
        return payments
            ?.filter(p => p?.name?.toLowerCase() === type.toLowerCase())
            ?.reduce((sum, p) => sum + Number(p?.amount || 0), 0);
    };

    const getPaidAmount = (payments = []) => {
        return payments?.reduce(
            (sum, p) => sum + Number(p?.amount || 0),
            0
        );
    };

    const getPayableAmount = (total = 0, payments = []) => {
        const paid = getPaidAmount(payments);
        return Number(total || 0) - paid;
    };


    return (
        <Header headers={header} setHeaders={setHeader} formdata={formdata}>
            <div className="text-end">
                <div className="py-2">
                    <ReactToPrint
                        trigger={() => (
                            <Button
                                className="bg-white border rounded border-green-500 hover:border-green-900"
                                type="button"
                                size="large"
                            >
                                A4 Print <PrinterOutlined className="text-lg" />
                            </Button>
                        )}
                        content={() => componentRef}
                        pageStyle={pageStyle}
                    />
                </div>
            </div>
            <Loadercomponent loader={loader}>
                <ScrollWrapper>
                    <table
                        className="w-full bg-white text-sm"
                        ref={(el) => (componentRef = el)}
                    >
                        <thead className="text-gray-500">
                            <tr>
                                <td className="border p-2">Sales Return</td>
                                <td className="border p-2">Customer</td>
                                <td className="border p-2">Branch</td>
                                <td className="border p-2">Date</td>
                                <td className="border p-2">Cash</td>
                                <td className="border p-2">Debit</td>
                                <td className="border p-2">Credit</td>
                                <td className="border p-2">Bank</td>
                                <td className="border p-2">Online</td>
                                <td className="border p-2">Cheque</td>
                                <td className="border p-2">Paid</td>
                                <td className="border p-2">Payable</td>
                                <td className="border p-2">Subtotal</td>
                                <td className="border p-4">Discount</td>
                                <td className="border p-2">Tax&nbsp;[VAT]</td>
                                <td className="border p-2">Total</td>
                            </tr>
                        </thead>
                        <tbody>
                            {body?.map((value, index) => {
                                return (
                                    <tr>
                                        <td className="border p-2 whitespace-nowrap">
                                            #SR-{value?.number}
                                        </td>
                                        <td className="border p-2">{value?.customer?.name}</td>
                                        <td className="border p-2">{value?.branch?.name}</td>
                                        <td className="border p-2">
                                            {value?.date
                                                ? formatDateDDMMYYYY(value?.date)
                                                : ""}
                                        </td>
                                        <td className="border p-2">
                                            {getPaymentAmount(value?.payments, "Cash").toFixed(3)}
                                        </td>

                                        <td className="border p-2">
                                            {getPaymentAmount(value?.payments, "Debit card").toFixed(3)}
                                        </td>

                                        <td className="border p-2">
                                            {getPaymentAmount(value?.payments, "Credit card").toFixed(3)}
                                        </td>

                                        <td className="border p-2">
                                            {getPaymentAmount(value?.payments, "Bank transfer").toFixed(3)}
                                        </td>

                                        <td className="border p-2">
                                            {getPaymentAmount(value?.payments, "Online payment").toFixed(3)}
                                        </td>

                                        <td className="border p-2">
                                            {getPaymentAmount(value?.payments, "Cheque").toFixed(3)}
                                        </td>
                                        <td className="border p-2">
                                            {value?.payments
                                                ?.reduce((sum, p) => sum + Number(p?.amount || 0), 0)
                                                .toFixed(3)}
                                        </td>
                                        <td className="border p-2">
                                            {getPayableAmount(value?.total, value?.payments).toFixed(3)}
                                        </td>
                                        <td className="border p-2">
                                            {value?.subtotal?.toFixed?.(3)}
                                        </td>
                                        <td className="border p-4">
                                            {value?.discount?.toFixed?.(3)}
                                        </td>
                                        <td className="border p-2">
                                            {value?.taxamount?.toFixed?.(3)}
                                        </td>
                                        <td className="border p-2">{value?.total?.toFixed?.(3)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        <tfoot>
                            <td className="border p-2 text-medium text-lg">TOTAL</td>
                            <td className="border p-2"></td>
                            <td className="border p-2"></td>
                            <td className="border p-2"></td>
                            <td className="border p-2">
                                {body
                                    ?.reduce(
                                        (acc, cur) => acc + getPaymentAmount(cur?.payments, "Cash"),
                                        0
                                    )
                                    .toFixed(3)}
                            </td>
                            <td className="border p-2">
                                {body
                                    ?.reduce(
                                        (acc, cur) => acc + getPaymentAmount(cur?.payments, "Debit card"),
                                        0
                                    )
                                    .toFixed(3)}
                            </td>
                            <td className="border p-2">
                                {body
                                    ?.reduce(
                                        (acc, cur) => acc + getPaymentAmount(cur?.payments, "Credit card"),
                                        0
                                    )
                                    .toFixed(3)}
                            </td>
                            <td className="border p-2">
                                {body
                                    ?.reduce(
                                        (acc, cur) => acc + getPaymentAmount(cur?.payments, "Bank transfer"),
                                        0
                                    )
                                    .toFixed(3)}
                            </td>
                            <td className="border p-2">
                                {body
                                    ?.reduce(
                                        (acc, cur) => acc + getPaymentAmount(cur?.payments, "Online payment"),
                                        0
                                    )
                                    .toFixed(3)}
                            </td>
                            <td className="border p-2">
                                {body
                                    ?.reduce(
                                        (acc, cur) => acc + getPaymentAmount(cur?.payments, "Cheque"),
                                        0
                                    )
                                    .toFixed(3)}
                            </td>
                            <td className="border p-2">
                                {body
                                    ?.reduce(
                                        (acc, cur) =>
                                            acc +
                                            cur?.payments?.reduce(
                                                (s, p) => s + Number(p?.amount || 0),
                                                0
                                            ),
                                        0
                                    )
                                    .toFixed(3)}
                            </td>
                            <td className="border p-2">
                                {body
                                    ?.reduce(
                                        (acc, cur) =>
                                            acc + getPayableAmount(cur?.total, cur?.payments),
                                        0
                                    )
                                    .toFixed(3)}
                            </td>
                            <td className="border p-2">
                                {body
                                    ?.reduce(
                                        (acc, currentValue) =>
                                            parseFloat(acc) + parseFloat(currentValue?.subtotal),
                                        0
                                    )
                                    ?.toFixed(3)}
                            </td>
                            <td className="border p-2">
                                {body
                                    ?.reduce(
                                        (acc, currentValue) =>
                                            parseFloat(acc) + parseFloat(currentValue?.discount),
                                        0
                                    )
                                    ?.toFixed(3)}
                            </td>
                            <td className="border p-2">
                                {body
                                    ?.reduce(
                                        (acc, currentValue) =>
                                            parseFloat(acc) + parseFloat(currentValue?.taxamount),
                                        0
                                    )
                                    ?.toFixed(3)}
                            </td>
                            <td className="border p-2 text-medium text-lg">
                                {body
                                    ?.reduce(
                                        (acc, currentValue) =>
                                            parseFloat(acc) + parseFloat(currentValue?.total),
                                        0
                                    )
                                    ?.toFixed(3)}
                            </td>
                        </tfoot>
                    </table>
                </ScrollWrapper>
            </Loadercomponent>
        </Header>
    );
};

export default SalesReportDashboard;
